<ng-template #modalViewTask let-modal class="modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header header-border" [ngClass]="running ? 'divisionR':'divisionNR'" style="height: 50px;">
            <h4 class="modal-title" id="topModalLabel">
                {{task.parentId ? ('BOARD.SUBTASK' | translate)
                : ('BOARD.TASK' | translate) }} {{task.title}}</h4>
            <button type="button" class="btn-close" tabindex="-1" aria-label="Close" (click)="cancel()">
            </button>
        </div>
        <div class="modal-body" [ngClass]="running ? 'divisionR':'divisionNR'">
            <app-ui-preloader id="spinner" [display]="loading"></app-ui-preloader>

            <div *ngIf="!loading" class="row row-request-info">
                <span>
                    <i class="mdi mdi-pound"></i>
                    <b>{{'MISC.ID' | translate}}:</b>
                    {{task.id}}
                </span>
                <span>
                    <i class="mdi mdi-account"></i>
                    <b>{{'RESOURCES.TABLE.CREATEDBY' | translate }}:</b>
                    {{task.author | xUser:'all'}}
                </span>
                <span *ngIf="task.sprintId && !edit">
                    <i class="mdi mdi-tag"></i>
                    <b>{{'BOARD.FORM.SPRINT' | translate }}:</b>
                    {{task.sprint?.name}}
                </span>
                <span *ngIf="!edit">
                    <i class="mdi mdi-table"></i>
                    <b>{{'BOARD.COLUMN' | translate}}:</b>
                    {{task.column == null ? 'Backlog': task.column?.name}}
                </span>
                <span *ngIf="!edit">
                    <i class="mdi mdi-tag"></i>
                    <b>{{'BOARD.FORM.TYPE' | translate}}:</b>
                    {{task.type?.description}}
                </span>
                <span *ngIf="!edit">
                    <i class="mdi mdi-alert-octagon-outline"></i>
                    <b>{{'BOARD.FORM.PRIORITY' | translate}}:</b>
                    {{task.priority?.description}}
                </span>
            </div>

            <div *ngIf="!loading" class="row p-1">
                <div class="scrollable order-2 order-sm-1 col col-12 col-sm-7 col-md-8 col-lg-9 mt-1">
                    <div *ngIf="!edit">

                        <div *ngIf="task.description">
                            <p class="label">{{ 'BOARD.FORM.DESCRIPTION' | translate }}: </p>
                            <p class="content-textarea content mt-n1">{{task.description}}</p>
                        </div>
                        <div *ngIf="task.notes" class="mt-1">
                            <p class="label">{{ 'BOARD.FORM.NOTES' | translate }}: </p>
                            <p class="content-textarea content mt-n1">{{task.notes}}</p>
                        </div>
                        <div *ngIf="task.impediments" class="mt-1">
                            <p class="label">{{ 'BOARD.FORM.IMPEDIMENTS' | translate }}: </p>
                            <p class="content-textarea content mt-n1">{{task.impediments}}</p>
                        </div>
                        <div class="mt-1 d-flex info-col">
                            <div *ngIf="task.sameDate && task.startDate" class="col col-auto d-flex">
                                <p class="label">{{ 'BOARD.FORM.DATE' | translate }}: </p>
                                <p class="content mt-n1">
                                    {{task.startDate | date:'yyyy-MM-dd'}}
                                </p>
                            </div>
                            <div *ngIf="!task.sameDate" class="d-flex">
                                <div *ngIf="task.startDate" class="col col-auto d-flex">
                                    <p class="label">{{ 'BOARD.FORM.STARTDATE' | translate }}: </p>
                                    <p *ngIf="task.startDate" class="content mt-n1">
                                        {{task.startDate | date:'yyyy-MM-dd'}}
                                    </p>
                                </div>
                                <div *ngIf="task.endDate" class="col col-auto d-flex">
                                    <p class="label">{{ 'BOARD.FORM.ENDDATE' | translate }}: </p>
                                    <p *ngIf="task.endDate" class="content mt-n1">
                                        {{task.endDate | date:'yyyy-MM-dd'}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1 d-flex info-col">
                            <div *ngIf="task.requestedBy!=null && task.requestedBy!=''" class="col col-auto d-flex">
                                <p class="label">{{ 'BOARD.FORM.REQUESTEDBY' | translate }}: </p>
                                <p class="content mt-0">{{task.requestedBy}} </p>
                            </div>
                            <div *ngIf="task.assignedId" class="col col-auto d-flex">
                                <p class="label">{{ 'BOARD.FORM.ASSIGNEDTO' | translate }}: </p>
                                <p class="content mt-0">{{task.assigned | xUser:'all'}}</p>
                            </div>
                        </div>
                        <div *ngIf="task.tags?.length > 0 && !edit" class="d-flex mt-1">
                            <p class="label">{{ 'BOARD.FORM.AREA' | translate }}: </p>
                            <div class="d-flex justify-content-center" *ngFor="let tag of task.tags">
                                <p class="mb-0 content badge badge-soft-secondary me-1">{{tag}}</p>
                            </div>
                        </div>

                        <p-panel [header]="('MISC.FILES' |translate) +' ('+files.length+')'" toggler="header"
                            [collapsed]="true" [toggleable]="true" class="mt-1">
                            <div class="row" id="modalFiles">
                                <div class="col col-5">
                                    <h5>{{'FILES.LIST' | translate}}</h5>
                                    <!-- file preview template -->
                                    <div *ngIf="files.length == 0">
                                        <p>{{'FILES.NOFILES' | translate}}</p>
                                    </div>
                                    <div *ngIf="files.length > 0 ">
                                        <div id="uploadPreviewTemplate" *ngFor="let item of files">
                                            <div class="card mt-1 mb-0 shadow-none border">
                                                <div class="row align-items-center" (click)="selectFile(item)"
                                                    style="cursor: pointer;">
                                                    <div class="col ps-2">
                                                        <div class="text-primary fw-bold">{{item.originalname}}</div>
                                                        <span class="text-muted mb-0">{{item.fileSize}}</span>
                                                    </div>
                                                    <div class="col-auto">
                                                        <a (click)="$event.stopPropagation()" [href]="item.url"
                                                            class="btn btn-link text-muted">
                                                            <i class="mdi mdi-download"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end file preview template -->
                                </div>
                                <div *ngIf="files.length > 0" class="col col-7" id="previewFile">
                                    <div class="preview-header" style="display: inline-flex;">
                                        <p class=" mb-0 viewLabel text-dark ">{{'FILES.PREVIEW' | translate}}</p>
                                        <a *ngIf="selectedFile!=null" class="a-link" (click)="preview()">
                                            <i class="mdi mdi-launch"></i>
                                            {{'FILES.NEWTAB' | translate}}
                                        </a>
                                    </div>
                                    <iframe *ngIf="selectedFile && !selectedFile.mimetype.includes('image')"
                                        [src]="selectedFile.urlSanitize"></iframe>
                                    <p-image *ngIf="selectedFile && selectedFile.mimetype.includes('image')"
                                        width="100%" class="bg-light preview-image" [src]="selectedFile.urlSanitize"
                                        [alt]="selectedFile.originalname" [preview]="true">
                                    </p-image>
                                </div>
                            </div>
                        </p-panel>
                        <p-panel [header]="('BOARD.SUBTASKS' |translate) +' ('+totalRecords+')'" toggler="header"
                            [collapsed]="true" [toggleable]="true">
                            <div class="row" style="overflow: visible;">
                                <div class="col-12">
                                    <form #displayForm="ngForm" class="mb-1">
                                        <div class="row">
                                            <div class="col-12 col-sm-6" *ngIf="pageSizeOptions.length">
                                                <div class="text-center text-sm-start">
                                                    <label class="form-label me-1 text-dark">{{ 'DATATABLE.SHOW' |
                                                        translate }}
                                                        <select
                                                            class="form-select form-select-sm  w-auto ms-1 me-1 d-inline"
                                                            name="pageSize" id="event-category" required
                                                            [(ngModel)]="pageSize" (ngModelChange)="pagination(1)">
                                                            <option *ngFor="let option of pageSizeOptions"
                                                                [value]="option">
                                                                {{option}}
                                                            </option>
                                                        </select>
                                                        {{ 'DATATABLE.ENTRIES' | translate }}</label>
                                                </div>
                                            </div><!-- end col-->
                                            <div class="col-12" [class.col-sm-6]="pageSizeOptions.length">
                                                <div
                                                    class="d-flex align-items-center justify-content-center justify-content-sm-end">
                                                    <input type="text" name="searchTerm"
                                                        placeholder="{{'SEARCH' | translate}}"
                                                        class="form-control form-control-sm d-inline w-auto ms-1"
                                                        aria-controls="advanced-table" [(ngModel)]="searchTerm"
                                                        (ngModelChange)="search()">
                                                </div>
                                            </div><!-- end col-->
                                        </div>
                                        <!-- end row -->
                                    </form>

                                    <div class="table-responsive">
                                        <table class=" table mb-0 table-borderless">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>{{ 'BOARD.FORM.TITLE' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.SCRUMCOLUMN' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.PRIORITY' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.TYPE' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.SPRINT' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.PLANNEDTASK' | translate }}</th>
                                                    <th class="td-date ">{{ 'BOARD.FORM.STARTDATE' | translate }}
                                                    </th>
                                                    <th class="td-date ">{{ 'BOARD.FORM.ENDDATE' | translate }}</th>
                                                    <th>{{ 'BOARD.FORM.ASSIGNEDTO' | translate }}</th>
                                                    <th *ngIf="'projects:board:tasks' | hasPermission"
                                                        class="optionsCustomized td-options-2">
                                                        {{'MISC.OPTIONS' | translate }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="noDataTableMessage" *ngIf="totalSubtasksSize == 0">
                                                    <td
                                                        [attr.colspan]="('projects:board:tasks' | hasPermission) ? 10 : 9">
                                                        {{ 'BOARD.EMPTYSUBTASKS' | translate }}
                                                    </td>
                                                </tr>
                                                <tr *ngFor="let row of subtasksListShow">
                                                    <td>{{ row.title}}</td>
                                                    <td>{{ row.column?.name}}</td>
                                                    <td>{{ row.priority?.clientDescription}}</td>
                                                    <td>{{ row.type?.clientDescription}}</td>
                                                    <td>{{ row.sprint?.name}}</td>
                                                    <td>
                                                        <span *ngIf="row.plannedTask == true"
                                                            class="badge badge-soft-success">{{
                                                            'BOARD.FORM.PLANNED' | translate }}</span>
                                                        <span *ngIf="row.plannedTask == false"
                                                            class="badge badge-soft-danger">{{
                                                            'BOARD.FORM.NOTPLANNED' | translate }}</span>
                                                    </td>
                                                    <td class="td-date ">{{ row.startDate | date: 'YYYY-MM-dd'}}
                                                    </td>
                                                    <td class="td-date ">{{ row.endDate | date: 'YYYY-MM-dd'}}</td>
                                                    <td>{{ row.assigned?.firstName}} {{ row.assigned?.lastName}}
                                                    </td>
                                                    <td *ngIf="'projects:board:tasks' | hasPermission"
                                                        class="optionsCustomized td-options-2">
                                                        <span
                                                            *ngIf="['projects:board:tasks:create', 'projects:board:tasks:read'] | hasPermission"
                                                            (click)="openSubtask(row)" class="action-icon">
                                                            <i class="mdi mdi-square-edit-outline"></i>
                                                        </span>
                                                        <span *ngIf="'projects:board:tasks:delete' | hasPermission"
                                                            (click)="deleteSubtaskPopUp(row)" class="action-icon">
                                                            <i class="mdi mdi-delete"></i>
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div class="d-flex flex-wrap justify-content-center align-items-center justify-content-md-between mt-1 table-pagination"
                                        *ngIf="pagination">
                                        <div class="text-dark">
                                            {{'DATATABLE.SHOWING' | translate}} {{startIndex }} {{'DATATABLE.TO' |
                                            translate}}
                                            {{endIndex}} {{'DATATABLE.OF' | translate}} {{totalRecords}}
                                            {{'DATATABLE.ENTRIES' | translate}}
                                        </div>
                                        <ngb-pagination [collectionSize]="totalSubtasksSize" [(page)]="page"
                                            [pageSize]="pageSize" [maxSize]="3" [boundaryLinks]="true"
                                            (pageChange)="pagination($event)"
                                            class="pagination-rounded custom-pagination">
                                        </ngb-pagination>
                                    </div>
                                </div>
                                <div class="mt-2 d-flex justify-content-center"
                                    *ngIf="'projects:board:tasks:create' | hasPermission">
                                    <button class="btn btn-primary btnSaveMinW2 btnAddBottom" (click)="addSubtask()">
                                        <i class="mdi mdi-plus"></i>
                                        {{'MISC.ADD'|translate}} {{'BOARD.ADDSUBTASK'|translate}}
                                    </button>
                                </div>
                            </div>

                        </p-panel>
                        <p-panel [header]="'BOARD.HISTORY' |translate" [collapsed]="true" toggler="header"
                            [toggleable]="true">
                            <app-task-history [taskId]="taskId"> </app-task-history>
                        </p-panel>
                        <p-panel [header]="'BOARD.COMMENTS' |translate" [collapsed]="false" toggler="header"
                            [toggleable]="true">
                            <div class="row" style="overflow: visible;">
                                <app-task-coments [taskId]="taskId" [projectId]="projectId" [modalV]="false">
                                </app-task-coments>
                            </div>
                        </p-panel>
                    </div>
                    <div *ngIf="edit">
                        <form [formGroup]="taskForm" class="form">
                            <div class="row mb-1">
                                <div class="col"
                                    [ngClass]="{'col-md-6 col-lg-6': projectRequest,'col-md-12 col-lg-12': !projectRequest}">
                                    <label class="form-label">{{ 'BOARD.FORM.TITLE' | translate }} <span
                                            class="text-error">*</span></label>
                                    <input type="text" [disabled]="loading" class="form-control" formControlName="title"
                                        required [ngClass]="{ 'is-invalid': submitted && formTask.title.invalid}">
                                    <div class="form-validation" *ngIf="submitted && formTask.title.errors?.required">
                                        {{ 'BOARD.FORM.TITLEERROR' | translate }}
                                    </div>
                                </div>
                                <div *ngIf="projectRequest" class="col col-12 col-xs-12 col-md-6 col-lg-6">
                                    <label class="form-label">{{ 'BOARD.FORM.REQUIREMENT' | translate }}</label>
                                    <ngx-select [allowClear]="true" [attr.disabled]="loading"
                                        formControlName="requirementId" [items]="requirementsList"
                                        (focus)="loadRequirements()" optionTextField="description"
                                        optionValueField="value">
                                        <ng-template ngx-select-option ngx-select-option-selected let-option>
                                            <div>
                                                <b>{{option.data.requirement}}</b>
                                                &nbsp;
                                                <small>({{option.data.group.name}})</small>
                                            </div>
                                            <div class="select-requirement">{{option.data.description}}</div>
                                        </ng-template>

                                        <ng-template ngx-select-option-not-found let-input>
                                            "{{input}}" not found
                                        </ng-template>
                                    </ngx-select>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col col-12 col-xs-12 col-md-12 col-lg-12">
                                    <label class="form-label">{{ 'REQUEST.DESCRIPTION' | translate }}</label>
                                    <textarea class="form-control" [disabled]="loading" formControlName="description"
                                        rows="5"></textarea>
                                </div>
                            </div>

                            <div class="row mb-1">
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.STARTDATE' | translate }}</label>
                                    <p-calendar formControlName="startDate" styleClass="input-group"
                                        inputStyleClass="form-control {{submitted && formTask.startDate.invalid ? 'is-invalid' : ''}}"
                                        [minDate]="minDate" [maxDate]="maxDate" dateFormat="yy-mm-dd" appendTo="body"
                                        [showIcon]="true" icon="mdi mdi-calendar-month" [autoZIndex]="true"
                                        [showTime]="true" [baseZIndex]="1000999999"
                                        (onSelect)="onChangeStartDate($event)">
                                    </p-calendar>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.ENDDATE' | translate }}</label>
                                    <p-calendar formControlName="endDate" styleClass="input-group"
                                        inputStyleClass="form-control {{submitted && formTask.endDate.invalid ? 'is-invalid' : ''}}"
                                        [minDate]="minDate" [maxDate]="maxDate" dateFormat="yy-mm-dd" appendTo="body"
                                        [showIcon]="true" icon="mdi mdi-calendar-month" [autoZIndex]="true"
                                        [showTime]="true" [baseZIndex]="1000999999"
                                        (onSelect)="validateEndDate($event)">
                                    </p-calendar>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label w">{{'BOARD.FORM.ESTIMATEDTIME' | translate}}</label>
                                    <p-inputMask slotChar="_" inputStyleClass="form-control" styleClass="input-group"
                                        formControlName="estimatedDuration" mask="99:99 h"
                                        [readonly]="loading"></p-inputMask>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3 checkB">
                                    <div class="form-check  form-switch mt-1" style="padding-left: 24px">
                                        <input type="checkbox" [disabled]="loading"
                                            class="form-check-input check-padding" formControlName="plannedTask">
                                        <label style="margin-left: 2px" class="form-check-label text-black">
                                            {{'BOARD.FORM.PLANNEDTASK' | translate}}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-1">
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.TYPE' | translate }}
                                        <span class="text-error">*</span></label>
                                    <ngx-select appendTo="body" [allowClear]="true" formControlName="typeId"
                                        [items]="typesList" (focus)="loadTypes()"
                                        [ngClass]="{ 'is-invalid': submitted && formTask.typeId.invalid}">
                                    </ngx-select>
                                    <div class="form-validation" *ngIf="submitted && formTask.typeId.errors?.required">
                                        {{ 'BOARD.FORM.TYPEERROR' | translate }}
                                    </div>
                                    <a class="a-link" (click)="openModalEvent()">
                                        <i class="mdi mdi-plus-circle"></i>
                                        {{'BOARD.FORM.ADDTYPE' | translate}}
                                    </a>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.PRIORITY' | translate }}
                                        <span class="text-error">*</span></label>
                                    <ngx-select appendTo="body" [allowClear]="true" [attr.disabled]="loading"
                                        formControlName="priorityId" [items]="prioritiesList" (focus)="loadPriorities()"
                                        [ngClass]="{ 'is-invalid': submitted && formTask.priorityId.invalid}">
                                    </ngx-select>
                                    <div class="form-validation"
                                        *ngIf="submitted && formTask.priorityId.errors?.required">
                                        {{ 'BOARD.FORM.PRIORITYERROR' | translate }}
                                    </div>
                                    <a class="a-link" (click)="openModalPriority()" [attr.disabled]="loading">
                                        <i class="mdi mdi-plus-circle"></i>
                                        {{'SETTINGS.PRIORITY.ADDPRIORITY' | translate}}
                                    </a>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.SCRUMCOLUMN' | translate }}</label>
                                    <ngx-select appendTo="body" [allowClear]="true" [attr.disabled]="loading"
                                        formControlName="columnId" [items]="columnsList" (focus)="loadColumns()">
                                    </ngx-select>
                                    <a class="a-link" (click)="openModalColumn()" [attr.disabled]="loading">
                                        <i class="mdi mdi-plus-circle"></i>
                                        {{'BOARD.FORM.ADDCOLUMN' | translate}}
                                    </a>
                                </div>
                                <div class="col col-12 col-md-3 col-lg-3">
                                    <label class="form-label">{{ 'BOARD.FORM.SPRINT' | translate }}</label>
                                    <ngx-select [allowClear]="true" [attr.disabled]="loading" formControlName="sprintId"
                                        [items]="sprintsList" (focus)="loadSprints()" (remove)="clearAssignedTo()"
                                        (select)="replaceFiltersData()">
                                    </ngx-select>
                                    <a class="a-link" (click)="openModalSprint()" [attr.disabled]="loading">
                                        <i class="mdi mdi-plus-circle"></i>
                                        {{'BOARD.FORM.ADDSPRINT' | translate}}
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col col-12 col-md-4 col-lg-4">
                                    <label class="form-label">{{ 'BOARD.FORM.ASSIGNEDTO' | translate }}</label>
                                    <ngx-select appendTo="body" [allowClear]="true" formControlName="assignedId"
                                        [items]="usersList" (focus)="loadUsers(null)" (typed)="loadUsers($event)"
                                        [attr.disabled]="loading">
                                    </ngx-select>
                                </div>
                                <div class="col col-12 col-md-4 col-lg-4 ">
                                    <label class="form-label">{{ 'BOARD.FORM.REQUESTEDBY' | translate }}</label>
                                    <input type="text" [disabled]="loading" class="form-control"
                                        formControlName="requestedBy">
                                </div>
                                <div class="col col-12 col-md-4 col-lg-4 ">
                                    <label class="form-label">{{ 'BOARD.FORM.AREA' | translate }}</label>
                                    <p-chips appendTo="body" styleClass="input-group"
                                        [placeholder]="translateService.instant('BOARD.TAGS')"
                                        inputStyleClass="form-control" formControlName="tags" separator=","></p-chips>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col col-12 col-xs-12  col-md-12 col-lg-12">
                                    <label class="form-label">{{ 'BOARD.FORM.IMPEDIMENTS' | translate }}</label>
                                    <textarea class="form-control" [disabled]="loading"
                                        formControlName="impediments"></textarea>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col col-12 col-xs-12  col-md-12 col-lg-12">
                                    <label class="form-label">{{ 'BOARD.FORM.NOTES' | translate }}</label>
                                    <textarea class="form-control" [disabled]="loading"
                                        formControlName="notes"></textarea>
                                </div>
                            </div>
                            <div class="row mb-1" *ngIf="'projects:board:tasks:create' | hasPermission">
                                <div class="btn btn-primary btn-action m-auto" [attr.disabled]="loading"
                                    (click)="showModalFiles()">
                                    <i class="mdi mdi-paperclip"></i>
                                    {{ 'MISC.FILES' | translate }}
                                    <span
                                        class="badge bg-danger rounded-circle noti-icon-badge">{{formTask.files.value.length}}</span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class=" order-1 order-sm-2  col col-12 col-sm-5 col-md-4 col-lg-3 mt-1">
                    <div class="d-flex">
                        <button (click)="edit ? clickButton(1) : null" type="button" class="btn waves-light w-50"
                            [ngClass]="{'btn-secondary': edit, 'btn-primary': !edit}">
                            <i class="mdi mdi-magnify me-1"></i>
                        </button>
                        <div class="me-1 ms-1"></div>
                        <button *ngIf="'projects:board:tasks:create' | hasPermission"
                            (click)="!edit ? clickButton(2) : null" type="button" class="btn waves-light w-50"
                            [ngClass]="{'btn-secondary': !edit, 'btn-primary': edit}">
                            <i class="mdi mdi-pencil me-1"></i>
                        </button>
                    </div>
                    <div class="mt-2">
                        <div class="row row-info">
                            <div class="d-flex">
                                <div class="name">{{ 'BOARD.FORM.ESTIMATEDTIME' | translate }}</div>
                                <div class="data">{{ task.estimatedDuration}}</div>
                            </div>
                        </div>
                        <div class="row row-info mt-1">
                            <div class="d-flex">
                                <div class="name">{{ 'PROJECTS.FORM.REALDURATION' | translate }}</div>
                                <div class="data">{{trackingTotal}}</div>

                            </div>
                        </div>
                        <div class="row row-info mt-1">
                            <div class="d-flex">
                                <div class="name">{{ 'PROJECTS.FORM.ESTIMATEDCOST' | translate }}</div>
                                <div class="data">
                                    {{ task.estimatedCost?task.estimatedCost:0| xCurrency: currency}}
                                </div>
                            </div>
                        </div>
                        <div class="row row-info mt-1">
                            <div class="d-flex">
                                <div class="name">{{ 'PROJECTS.FORM.REALCOST' | translate }}</div>
                                <div class="data">
                                    {{ task.realCost?task.realCost:0 | xCurrency: currency}}
                                </div>
                            </div>
                        </div>

                        <div *ngIf="(task.assigned||this.loggedInUser?.isAdmin) && !edit" class="d-flex mt-2">
                            <button *ngIf="running == false && ('projects:board:tasks:create' | hasPermission)"
                                style="padding: 4px !important;" class="btn btn-success btn-action w-50"
                                [disabled]="loading" (click)="beforeToggle()">
                                <i class="mdi sprintButton mdi-play"></i>
                                {{'BOARD.START'| translate}}
                            </button>
                            <button *ngIf="running == true && ('projects:board:tasks:create' | hasPermission)"
                                style="padding: 4px !important;" class="btn btn-warn btn-action w-50"
                                [disabled]="loading" (click)="beforeToggle()">
                                <i class="mdi sprintButton mdi-pause"></i>
                                {{'BOARD.SUSPEND' | translate }}
                            </button>
                            <div class="me-1 ms-1"></div>
                            <div class="input-group w-50 ">
                                <input type="time" style="padding:4px !important" class="form-control"
                                    [ngModelOptions]="{standalone: true}" [disabled]="true" [(ngModel)]="trackingTotal">
                            </div>
                        </div>
                        <div *ngIf="(task.assigned||this.loggedInUser?.isAdmin) && !running && edit && ('projects:board:tasks:create' | hasPermission)"
                            class="mt-1">
                            <input type="text" [disabled]="loading" class="form-control w-100"
                                [placeholder]="'00:00:00'" [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="trackingTotalUpdate">
                            <button style="padding: 4px !important;"
                                class="btn btn-primary btnSaveBottom  btnSaveMinW2  btn-action w-100 mt-1"
                                [disabled]="loading" (click)="timeUpdate()">
                                {{'BOARD.UPDATE'| translate}}
                            </button>
                        </div>
                        <div *ngIf="(task.assigned||this.loggedInUser?.isAdmin) && ('projects:board:tasks:create' | hasPermission)"
                            class="d-flex mt-1">
                            <button (click)="op.toggle($event);loadTableTimesList()" type="button"
                                class="btn waves-light w-100 btn-secondary tableButton">
                                <i class="mdi mdi-table"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-center">

            <button class="btn btn-outline-primary waves-effect waves-light btnSaveBottom btnSaveMinW2 me-2"
                *ngIf="projectId != 0 && ('projects:board:tasks:delete' | hasPermission)" [disabled]="loading"
                (click)="deleteTaskPopUP()">
                {{'MISC.DELETE' | translate }}
            </button>
            <button class="btn btn-primary waves-effect waves-light btnSaveBottom btnSaveMinW2"
                *ngIf="('projects:board:tasks:create' | hasPermission) && edit == true" [disabled]="loading"
                (click)="editF()">
                {{'MISC.SAVE'| translate}}
            </button>
        </div>
    </div>
</ng-template>

<!-- Priority Modal -->
<app-priority-modal #modalPriority></app-priority-modal>
<!-- end Priority Modal -->

<!-- Modal Event -->
<app-event-modal #modalEvent></app-event-modal>
<!-- end Modal Event -->

<!-- Modal Column -->
<app-column-modal #modalColumn></app-column-modal>
<!-- end Modal Column -->

<!-- Modal Files -->
<app-modal-files #modal [onlyPreview]="false" (saveModal)="saveNeedFiles($event)"
    (closeModal)="this.showModal = false; showModalRequestFiles ? showModalRequestFiles = false : null;">
</app-modal-files>
<!-- end Modal Files -->

<div style="bottom: 0px;">
    <p-overlayPanel [showCloseIcon]="true" [style]="{minWidth: '750px'}" #op [baseZIndex]="999999999999">
        <app-times-list #timesList [taskId]="taskId" [projectId]="projectId"></app-times-list>
    </p-overlayPanel>
</div>